@if (!href) {
    <a>
        <ng-container *ngTemplateOutlet="itemTemplate" />
    </a>
} @else {
    <a [href]="href" [vnSpeculativeLink]="href">
        <ng-container *ngTemplateOutlet="itemTemplate" />
    </a>
}

<ng-template #itemTemplate>
    <ds-list-item
        class="list-item-alignment"
        [title]="title ?? ''"
        [subtitle]="subTitle ?? ''"
        [selected]="isActive()"
        [boldTitle]="boldTitle()"
        (click)="clicked()">
        @if (showStartSlot()) {
            <span slot="start">
                @if (icon) {
                    <span class="icon-alignment">
                        <vn-icon [name]="icon" [size]="iconSize ?? ''" />
                    </span>
                }
                <ng-content select="[item-icon]" />
            </span>
        }

        <div class="list-item-end" slot="end">
            <ng-content select="[competition-logo]" />
            @if (badge()) {
                <ng-content select="[badge]" />
            }
            @if (!title) {
                <ng-content select="[item-title]" />
            }
            @if (count) {
                <ds-notification-bubble variant="neutral" size="medium">
                    {{ count }}
                </ds-notification-bubble>
            }
            @if (arrow()) {
                <span class="arrow-icon">
                    <vn-icon name="theme-right" [size]="arrowIconSize()" />
                </span>
            }
        </div>
    </ds-list-item>
    <ng-content select="[vertical-divider]" />
</ng-template>
@if (isShowBorder()) {
    <ds-divider class="list-item-divider" />
}
